import React, { useState, useEffect } from "react";
import useWindowDimensions from "../../get-diemensions/UseWindowDiemensions";
import { colors } from "../../themes/Colors";

import { GhostButton, BaseButton, TabButton } from "../atoms";

const MenuDisplayHeader = ({
  onSignUpClick,
  onLogInClick,
  onAboutClick,
  onLegalityClick,
  onPharmaciesClick,
  onPractionersClick,
  onContactClick,
  selected,
  width,
}) => {
  //   const { width, height } = useWindowDimensions();

  const [menuDisplay, setMenuDisplay] = useState(false);

  const returnWidth = () => {
    return width;
  };
  console.log(width);
  useEffect(() => {
    if (width) {
      returnWidth();
    }
  }, [width]);
  useEffect(() => {
    returnWidth();
  }, []);
  return (
    <div
      style={{
        width: width,
        maxWidth: 1440,
        minHeight: 60,
        height: 66,
        backgroundColor: colors.white,
        display: "flex",
        alignItems: "center",
        position: "fixed",
        top: 0,
        zIndex: 100,
      }}
    >
      <img
        alt="main logo"
        src={require("../../images/logos/Alter-Pharm Logo Final 1.png")}
        height={"70%"}
        style={{ marginLeft: 20 }}
      />
      <div style={{ flex: 1 }} />

      {width > 599 ? (
        <TabButton
          selected={selected === "about" ? true : false}
          label={"About"}
          marginRight={10}
          width={90}
          fontWeight={"normal"}
          onClick={onAboutClick}
          borderColor={selected === "about" ? colors.secondary : colors.primary}
        />
      ) : null}
      {/* <TabButton
        selected={selected === "legality" ? true : false}
        label={"Legality"}
        marginRight={10}
        width={90}
        fontWeight={"normal"}
        onClick={onLegalityClick}
        borderColor={
          selected === "legality" ? colors.secondary : colors.primary
        }
      /> */}
      {width > 599 ? (
        <TabButton
          selected={selected === "pharmacies" ? true : false}
          label={"Pharmacies"}
          marginRight={10}
          width={100}
          fontWeight={"normal"}
          onClick={onPharmaciesClick}
          borderColor={
            selected === "pharmacies" ? colors.secondary : colors.primary
          }
        />
      ) : null}
      {/* <TabButton
        selected={selected === "practioners" ? true : false}
        label={"Practioners"}
        marginRight={10}
        width={100}
        fontWeight={"normal"}
        onClick={onPractionersClick}
        borderColor={
          selected === "practioners" ? colors.secondary : colors.primary
        }
      /> */}
      {width > 599 ? (
        <TabButton
          label={"Contact"}
          marginRight={10}
          width={90}
          fontWeight={"normal"}
          onClick={onContactClick}
          borderColor={colors.primary}
        />
      ) : null}
      {width > 599 ? (
        <TabButton
          label={"Log In"}
          marginRight={10}
          width={90}
          fontWeight={"normal"}
          onClick={onLogInClick}
          borderColor={colors.primary}
        />
      ) : null}

      {width > 599 ? (
        <BaseButton
          label={"SIGN UP"}
          marginRight={10}
          width={120}
          onClick={onSignUpClick}
        />
      ) : (
        <div>
          <img
            onClick={() => setMenuDisplay(menuDisplay ? false : true)}
            alt="menu icon"
            src={require("../../images/icons/Menu.png")}
            height={20}
            width={20}
            style={{ marginRight: 20 }}
          />
        </div>
      )}
      {menuDisplay ? (
        <div
          style={{
            backgroundColor: colors.white,
            width: width,
            paddingTop: 10,
            paddingBottom: 10,
            position: "absolute",
            // borderStyle: "solid",
            bottom: -220,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <TabButton
            selected={selected === "about" ? true : false}
            label={"About"}
            //   marginRight={10}
            width={"90%"}
            fontWeight={"normal"}
            onClick={onAboutClick}
            borderColor={
              selected === "about" ? colors.secondary : colors.primary
            }
          />
          <TabButton
            selected={selected === "pharmacies" ? true : false}
            label={"Pharmacies"}
            //   marginRight={10}
            width={"90%"}
            fontWeight={"normal"}
            onClick={onPharmaciesClick}
            borderColor={
              selected === "pharmacies" ? colors.secondary : colors.primary
            }
          />
          <TabButton
            label={"Contact"}
            width={"90%"}
            fontWeight={"normal"}
            onClick={onContactClick}
            borderColor={colors.primary}
          />
          <TabButton
            label={"Log In"}
            //   marginRight={10}
            width={"90%"}
            fontWeight={"normal"}
            onClick={onLogInClick}
            borderColor={colors.primary}
          />
          <BaseButton
            label={"SIGN UP"}
            //   marginRight={10}
            width={"90%"}
            onClick={onSignUpClick}
          />
        </div>
      ) : null}
    </div>
  );
};

export default MenuDisplayHeader;
